import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { ParkingOperatorDto } from '../../../../api/gen';
import { ParkingOperatorItemComponent } from '../parking-operator-item/parking-operator-item.component';
import { PaginationConfig } from '../../../models/config/pagination-config';
import { ResponsiveBaseComponent } from 'shared-lib';

@Component({
  selector: 'app-operators-list',
  imports: [
    CommonModule,
    MatPaginatorModule,
    MatProgressSpinnerModule,
    MatIconModule,
    ParkingOperatorItemComponent
  ],
  templateUrl: './operators-list.component.html',
  styleUrl: './operators-list.component.scss'
})
export class OperatorsListComponent extends ResponsiveBaseComponent {
  @Input() operators: ParkingOperatorDto[] = [];
  @Input() paginationConfig: PaginationConfig | null = null;
  @Input() isLoading: boolean = false;

  @Output() pageChange = new EventEmitter<PageEvent>();
  @Output() editOperator = new EventEmitter<ParkingOperatorDto>();
  @Output() deleteOperator = new EventEmitter<ParkingOperatorDto>();
  @Output() viewOperatorDetails = new EventEmitter<ParkingOperatorDto>();
  @Output() assignParkingSpace = new EventEmitter<ParkingOperatorDto>();
  @Output() unassignParkingSpace = new EventEmitter<ParkingOperatorDto>();

  onPageChange(event: PageEvent): void {
    this.pageChange.emit(event);
  }

  onEditOperator(operator: ParkingOperatorDto): void {
    this.editOperator.emit(operator);
  }

  onDeleteOperator(operator: ParkingOperatorDto): void {
    this.deleteOperator.emit(operator);
  }

  onViewOperatorDetails(operator: ParkingOperatorDto): void {
    this.viewOperatorDetails.emit(operator);
  }

  onAssignParkingSpace(operator: ParkingOperatorDto): void {
    this.assignParkingSpace.emit(operator);
  }

  onUnassignParkingSpace(operator: ParkingOperatorDto): void {
    this.unassignParkingSpace.emit(operator);
  }
}
